"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CatalogTabs_1 = __importDefault(require("./CatalogTabs"));
exports.default = CatalogTabs_1.default;
